<template>
  <div class="overlay">
    <div class="heading">
      <div class="h4">Karte Besucherverteilung</div>
      <div class="ficon tooltip">
        
        <span class="tooltiptext">
          Die Karte (Heatmap) zeigt die Verteilung der Besucher in der Ausstellung.
          Je intensiver die Farbe, desto mehr Besucher befanden sich im gewählten
          Zeitraum am entsprechenden Punkt.
        </span>
      </div>
      <div class="date-control">
        <div class="date-input">
          {{ datePointer.toLocaleDateString() }}
          -
          {{ datePointer.toLocaleDateString() }}
          <span class="ficon"></span>
        </div>
        <div class="time-input">
          {{ focusAStart.getHours() + ':'
          + (focusAStart.getMinutes() &lt; 10 ? '0' : '' )
          + focusAStart.getMinutes() }} -           {{ focusAEnd.getHours() + ':'
          + (focusAEnd.getMinutes() &lt; 10 ? '0' : '' )
          + focusAEnd.getMinutes() }}
        </div>
      </div>
    </div>
    <div class="media-controls">
      <div class="left">
        <div class="date">
          {{ datePointer.toLocaleDateString() }}
          {{ datePointer.getHours() + ':'
          + (datePointer.getMinutes() &lt; 10 ? '0' : '' )
          + datePointer.getMinutes() }}
        </div>

        <div id="timeline" :class="{ show: playbackStarted }">
        </div>

        <div class="media-control-default"
             :class="{ show: !playbackStarted }"
             v-if="!playbackStarted"
             @click="initPlayback">
          <span class="ficon"></span>
          Play
        </div>

        <div class="media-control" :class="{ show: playbackStarted }">
          <div v-if="!playing" @click="startPlayback">
            <span class="ficon"></span>
            Play
          </div>
          <div v-if="playing" @click="stopPlayback">
            <span class="ficon"></span>
            Pause
          </div>
<!--          <div @click="switchPlayback">-->
<!--            <span class="ficon"></span>-->
<!--            Stop-->
<!--          </div>-->
          <div @click="callResetPlayback">
            <span class="ficon"></span>
            Reset
          </div>
        </div>
      </div>
      <div class="right">
        <div class="heatmap">
          <label>als Heatmap anzeigen</label>
          <span>
            <TSwitch :checked="heatmapEnabledSwitch" :anotherFunction="setHeatmapStatus">
            </TSwitch>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Two from 'two.js';
import TSwitch from '@/components/base/TSwitch.vue';

export default {
  name: 'MediaControls',
  components: {
    TSwitch,
  },
  data() {
    return {
      heatmapEnabledSwitch: true,
      playbackStarted: false,
      heatmapClicked: false,
    };
  },
  computed: {
    playing() {
      return this.$store.state.playing;
    },
    datePointer() {
      return this.$store.state.datePointer;
    },
    focusAStart() {
      return this.$store.state.focusAStart;
    },
    focusAEnd() {
      return this.$store.state.focusAEnd;
    },
    percent() {
      return 100 - Math.round(
        ((this.$store.state.focusAEnd.getTime() - this.$store.state.datePointer.getTime())
        * 100)
        / (this.$store.state.focusAEnd.getTime() - this.$store.state.focusAStart.getTime()),
      );
    },
    percentFull() {
      return (100 - (
        (this.$store.state.focusAEnd.getTime() - this.$store.state.datePointer.getTime()) * 100)
        / (this.$store.state.focusAEnd.getTime() - this.$store.state.focusAStart.getTime())) / 100;
    },
    // heatmapEnabled() {
    //   return this.$store.state.heatmapEnabled;
    // },
  },
  props: ['someFunction', 'resetPlayback'],
  mounted() {
    this.init();
    // this.load();
  },
  methods: {
    init() {

    },
    initPlayback() {
      this.playbackStarted = true;
      this.heatmapEnabledSwitch = false;
      this.someFunction(this.heatmapEnabledSwitch);

      let progress = 0;
      const goal = 280;

      const timeline = document.getElementById('timeline');
      const two = new Two({
        width: 300,
        height: 45,
      }).appendTo(timeline);

      const line = two.makePath([new Two.Anchor(10, 25), new Two.Anchor(290, 25)],
        false, false, false);
      const markerLine = two.makePath([new Two.Anchor(10, 25), new Two.Anchor(10, 25)],
        false, false, false);
      const triangle = two.makePolygon(10, 10, 7, 3);

      line.stroke = '#FCD8D5';
      line.linewidth = 5;
      line.join = 'round';

      markerLine.stroke = '#F56457';
      markerLine.linewidth = 5;
      markerLine.join = 'round';

      triangle.fill = '#F56457';
      triangle.rotation = Math.PI;
      triangle.noStroke();

      two.update();

      const wait = 2;
      let waitC = 0;

      two.bind('update', () => {
        if (waitC <= wait) {
          waitC += 1;
        } else {
          waitC = 0;
          progress = goal * this.percentFull;
          markerLine.vertices[1].set(progress, 0);
          triangle.translation = new Two.Vector(10 + progress, 10);
        }
      }).play();


      this.$store.state.playing = true;
    },
    startPlayback() {
      this.$store.state.playing = true;
    },
    stopPlayback() {
      this.$store.state.playing = false;
    },
    switchPlayback() {
      this.$store.commit('switchPlayback');
    },
    callResetPlayback() {
      this.resetPlayback();
    },
    setHeatmapStatus() {
      this.heatmapEnabledSwitch = !this.heatmapEnabledSwitch;
      console.log(this.heatmapEnabledSwitch);
      this.someFunction(this.heatmapEnabledSwitch);
    },
  },
};
</script>

<style scoped lang='scss'>
  @import './../assets/scss/theme';

  .overlay {
    padding: 0 0 1.5rem;

    .heading {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .h4 {
        font-family: "Hind Madurai", sans-serif;
        font-weight: $font-weight-semi-bold;
        font-size: 1.5rem;
        margin: 0;
        width: max-content;
      }

      .tooltip {
        cursor: help;
        position: relative;
        display: inline-block;
        transition: color .1s ease-in-out;

        &:hover {
          color: $orange100;
        }
      }

      .tooltip .tooltiptext {
        visibility: hidden;
        width: 50rem;
        background-color: $white;
        color: $dark75;
        /*text-align: center;*/
        padding: 0.5rem;
        border-radius: 4px;
        border: 1px solid $dark25;
        box-shadow: 0 0 5px 5px transparentize($dark25, .85);

        position: absolute;
        z-index: 1;
        top: -100%;
        left: 50%;
        margin-left: 1rem;

        opacity: 0;
        transition: opacity 0.3s ease-in-out;
      }

      .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }

      .ficon {
        font-size: 1rem;
        font: $font-weight-regular;
        color: $black25;
        align-self: start;
        margin-top: 0.2rem;
        margin-left: 0.5rem;
      }

      .date-control {
        display: flex;
        margin-left: 10rem;
        cursor: default;
        flex-wrap: wrap;

        @media (max-width: 1199.98px) {
            display: none;
            margin-left: 0;
            margin-top: 2rem;
        }

        .date-input {
          border-radius: 8px;
          padding: 0.25rem 0.75rem;
          background: $dark10;
          color: $dark50;
          display: flex;
          align-items: center;
        }

        .time-input {
          border-radius: 8px;
          padding: 0.25rem 0.75rem;
          background: $dark10;
          color: $dark50;
          margin-left: 1.5rem;
          display: flex;
          align-items: center;
        }
      }
    }

    .media-controls {
      font-weight: $font-weight-semi-bold;
      font-size: 1.125rem;
      margin-top: 2rem;
      color: $orange100;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 80%;
      height: 4rem;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        #timeline {
          opacity: 0;
        }

        .show {
          opacity: 1 !important;
        }
      }

      .right {
        display: flex;
      }

      .date {
        margin-right: 1rem;
        min-width: 8rem;
      }

      .media-control-default {
        color: $white;
        background: $dark100;
        padding: .4rem 1rem;
        border-radius: 8px;
        opacity: 0;
        cursor: pointer;

        &:hover {
          background: $orange100;
        }
      }

      .media-control {
        margin-left: 1rem;
        color: $black100;
        display: flex;
        opacity: 0;

        >div {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding-left: 1rem;

          >span {
            margin-right: 0.5rem;
          }
        }
      }

      .heatmap {
        color: $black100;
        font-weight: $font-weight-regular;

        >label {
          margin-right: 1rem;
        }
      }
    }

    .show {
      opacity: 1;
    }
  }
</style>
